import React from "react";
import type {WorkflowStageContext} from "./stage";
import {AmountAndRateStage, ReceiptStage} from "./WorkflowStageControls";

export function ExternalPayout({context}: {context: WorkflowStageContext}): JSX.Element {
    return (
        <>
            <ReceiptStage number="1" title="Доказательство оплаты" hint="обязательно" context={context}/>
            <AmountAndRateStage number="2" title="Фактически проведено" isIncome={false} context={context}/>
        </>
    );
}
